import { css, cx } from "@linaria/core";
import { useId } from "react";

import { colors } from "../design-tokens/colors";

import { getDefaultHeight, SVG } from "./utils";
import { easings } from "../css-tokens/easings";

type Props = {
  accentColor?: string;
  runAnimation?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const downloadIconArrowCls = css`
  overflow: hidden;
`;
export const DOWNLOAD_ICON_ANIMATION_DURATION_MS = 800;

export const ComplexDownloadIcon: React.FC<Props> = ({
  accentColor = colors.accent(),
  runAnimation,
  ...svgProps
}) => {
  const baseId = useId();

  return (
    <SVG
      viewBox="0 0 159.89 184.28"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 184.28)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
    >
      <filter
        id={`${baseId}-a`}
        filterUnits="userSpaceOnUse"
        height="184.28"
        width="159.89"
        x="0"
        y="0"
      >
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation="15" />
        <feFlood floodOpacity=".16" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <g transform="translate(-1031.12 -688)">
        <circle
          cx="1113.41"
          cy="802.59"
          className={backgroundShadow}
          r="56.41"
        />
        <g filter={`url(#${baseId}-a)`} transform="translate(1031.12 688)">
          <g fill="#fff" stroke="#e0e0e0" transform="translate(45 45)">
            <rect height="94.28" rx="2" stroke="none" width="69.89" />
            <rect
              fill="none"
              height="93.28"
              rx="1.5"
              width="68.89"
              x=".5"
              y=".5"
            />
          </g>
        </g>
        <g fill="#fff" stroke="#e0e0e0">
          <rect
            height="93.62"
            rx="2"
            stroke="none"
            width="69.89"
            x="1082.05"
            y="739.59"
          />
          <rect
            fill="none"
            height="92.62"
            rx="1.5"
            width="68.89"
            x="1082.55"
            y="740.09"
          />
        </g>
        <path d="m1095.9 757.4h25.71v5.27h-25.71z" fill={accentColor} />
        <path
          d="m1095.9 769.26h42.85v1.98h-42.85zm0 18.46h42.85v1.98h-42.85zm0-13.84h42.85v1.98h-42.85zm0 18.46h42.85v1.98h-42.85zm0-13.84h42.85v1.97h-42.85zm0 18.45h42.85v1.98h-42.85z"
          fill="#707070"
          opacity=".27"
        />
        <g className={downloadIconArrowCls} fill={accentColor}>
          <g className={cx(animationStyle, runAnimation && "runAnimation")}>
            <path d="m1138.75 847.06-11.2-9.23h22.41z" />
            <path d="m1136.12 820.03h5.93v20.44h-5.93z" />
          </g>
        </g>
      </g>
    </SVG>
  );
};

export const backgroundShadow = css`
  ${colors.selectors.primary.isLight()} & {
    fill: ${colors.black({ alpha: 0.1 })};
  }

  ${colors.selectors.primary.isDark()} & {
    fill: ${colors.gray.sim00({ alpha: 0.2 })};
  }
`;

const animationStyle = css`
  &.runAnimation {
    animation: download-animation ${DOWNLOAD_ICON_ANIMATION_DURATION_MS}ms
      ${easings.inOutQuart} infinite;
  }

  @keyframes download-animation {
    0% {
      opacity: 1;
      transform: translateY(0);
    }

    50% {
      opacity: 0;
      transform: translateY(15px);
    }

    50.001% {
      opacity: 0;
      transform: translateY(-5px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
